<template>
  <form>
    <v-row class="py-0">
      <v-col class="py-0" cols="12" sm="12" md="11" lg="11">
        <form-edit :form="settingTax" ref="formEdit" v-if="!edit"></form-edit>
        <detail :form="settingTax" v-if="edit"></detail>
      </v-col>
      <v-col class="py-0" cols="12" sm="12" md="1" lg="1">
        <v-row v-if="!edit">
          <v-col cols="12">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="success" v-on="on" @click="updateItem" class="mr-3">
                  <v-icon>
                    mdi-content-save
                  </v-icon>
                </v-btn>
              </template>
              <span>Save</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row v-if="edit">
          <v-col cols="12">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="success" v-on="on" @click="editItem">
                  <v-icon>
                    mdi-pencil
                  </v-icon>
                </v-btn>
              </template>
              <span>Edit</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row v-if="edit">
          <v-col cols="12">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="error" v-on="on" @click.stop="deleteDialog">
                  <v-icon>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </template>
              <span>Delete</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row v-if="!edit">
          <v-col cols="12">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="error" v-on="on" @click="cancel">
                  <v-icon>
                    mdi-close
                  </v-icon>
                </v-btn>
              </template>
              <span>Close</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row v-if="edit">
          <v-col cols="12">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" v-on="on" @click="back">
                  <v-icon>
                    mdi-arrow-left
                  </v-icon>
                </v-btn>
              </template>
              <span>Back</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row v-if="edit">
          <v-col cols="12">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="blue-grey" dark v-on="on" @click="dialogAuditHistory = true">
                  <v-icon>mdi-history</v-icon>
                </v-btn>
              </template>
              <span>History</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dialog-delete
      :id="id"
      :dialog="dialog"
      :invoiceNumber="`${settingTax.id}`"
      title="Setting Tax"
      @deleteItem="deleteItem"
      @close="close"
    ></dialog-delete>
    <dialog-audit-history
      :dialog="dialogAuditHistory"
      entity-type="SettingTax"
      :entity-id="id"
      @close="dialogAuditHistory = false"
    ></dialog-audit-history>
  </form>
</template>

<script>
import Detail from "./DetailSettingTax";
import FormEdit from "./EditSettingTax";
import DialogDelete from "@/components/DialogDelete";
import DialogAuditHistory from "@/components/DialogAuditHistory.vue";

export default {
  name: "setting-tax-view",
  components: {
    Detail,
    "form-edit": FormEdit,
    "dialog-delete": DialogDelete,
    "dialog-audit-history": DialogAuditHistory,
  },
  props: {
    id: Number,
  },
  data: () => ({
    edit: true,
    dialog: false,
    dialogAuditHistory: false,
    settingTax: {},
  }),
  methods: {
    async getSettingTax() {
      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("settingTax/getById", this.id)
        .then(response => {
          this.settingTax = response.data;
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
    back() {
      this.$router.go(-1);
    },
    editItem() {
      this.edit = false;
    },
    updateItem() {
      this.$refs.formEdit.update();
    },
    async deleteItem(id) {
      await this.$store.dispatch("settingTax/delete", id);
      this.dialog = false;
    },
    deleteDialog() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    cancel() {
      this.getInitialData();
      this.edit = true;
    },
  },
  mounted() {
    this.getSettingTax();
  },
};
</script>

<style></style>
